var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-input-wrapper" },
    [
      _c("date-picker", {
        attrs: {
          range: "",
          "disabled-date": _vm.disabledDate,
          editable: false,
          clearable: true,
          placeholder: "Shipping ASAP",
          format: _vm.displayFormat,
          "value-type": "date",
          "input-class": "bdp-input",
          "popup-class": "bdp-popup",
          "append-to-body": true
        },
        on: { change: _vm.onRangeChange },
        model: {
          value: _vm.innerRange,
          callback: function($$v) {
            _vm.innerRange = $$v
          },
          expression: "innerRange"
        }
      }),
      _vm._v(" "),
      _vm.hasValue
        ? _c("div", { staticClass: "clear-popover" }, [
            _vm._v("\n    Clear Date\n  ")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }